import script from "./RateGroupMainPage.vue?vue&type=script&setup=true&lang=js"
export * from "./RateGroupMainPage.vue?vue&type=script&setup=true&lang=js"

import "./RateGroupMainPage.vue?vue&type=style&index=0&id=8916cc96&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8916cc96"]])

export default __exports__